export default __webpack_public_path__ + "static/media/Header.35d4c124.png";